import { render, staticRenderFns } from "./OperationLog.vue?vue&type=template&id=488804c2&scoped=true&"
import script from "./OperationLog.vue?vue&type=script&lang=js&"
export * from "./OperationLog.vue?vue&type=script&lang=js&"
import style0 from "./OperationLog.vue?vue&type=style&index=0&id=488804c2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488804c2",
  null
  
)

export default component.exports